import { useMemo, useState } from "react";
import { jobs } from "../../../static/jobsData";
import { getActiveJobs, filterJobs } from "../../../static/jobsHelpers";
import { DEPARTMENTS, LOCATIONS } from "../../../static/filterOptions";
import "../styles/careers.css";

import Hero from "./01_hero";
import SearchBar from "./02_searchBar";
import Listings from "./03_listings";
import Cta from "./04_cta";

// NOTE: no <header>/<footer> here — plug in your existing site Header/Footer
// around this page in your router layout, same as CareersLanding.
//
// Department/Location dropdown options live in static/filterOptions.js —
// edit DEPARTMENTS / LOCATIONS there, not here.

export default function CareersOpenings() {
  const [keyword, setKeyword] = useState("");
  const [department, setDepartment] = useState(""); // "" = All Departments
  const [location, setLocation] = useState("");     // "" = All Locations

  const allActive = useMemo(() => getActiveJobs(jobs), []);
  const filtered = useMemo(
    () => filterJobs(allActive, { keyword, department, location }),
    [allActive, keyword, department, location]
  );

  const countLabel =
    allActive.length === 0
      ? "No open positions at the moment"
      : filtered.length === allActive.length
      ? `Showing ${filtered.length} of ${allActive.length} roles`
      : `Showing ${filtered.length} of ${allActive.length} roles matching your search`;

  return (
    <div className="vm-careers mt-[125px] font-poppins">
      <Hero />
      <SearchBar
        keyword={keyword}
        setKeyword={setKeyword}
        department={department}
        setDepartment={setDepartment}
        location={location}
        setLocation={setLocation}
        departments={DEPARTMENTS}
        locations={LOCATIONS}
      />
      <Listings filtered={filtered} allActive={allActive} countLabel={countLabel} />
      <Cta />
    </div>
  );
}
